// extracted by mini-css-extract-plugin
export default {"Form":"Form_Form__QI4-G","Form-hiddenSubmitButton":"Form_Form-hiddenSubmitButton__xi6CN"};